import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { InAppBrowser } from "@ionic-native/in-app-browser";

import { NavController } from 'ionic-angular';


import { SubmenuPage } from '../../pages/submenu/submenu';
import { sample } from 'lodash';
import { PhcApp, PhcAppMenu, PhcAppMenuItem, PhcLink } from '../../classes/phc-app/phc-app';

import { WpProvider } from '../../providers/wp/wp';

import {SpinnerDialog} from "@ionic-native/spinner-dialog";
import { PhcLinkServiceProvider } from '../../providers/phc-link-service/phc-link-service';
import { AnalyticsProvider } from '../../providers/analytics/analytics';

/**
 * Generated class for the PhcMenuComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'phc-menu',
  templateUrl: 'phc-menu.html'
})
export class PhcMenuComponent implements OnInit, OnDestroy{

  @Input() items: Array<PhcAppMenuItem|PhcAppMenu> = [];
  phcApp: PhcApp;

  animating = null;
  animateCycle;


  constructor(private iab: InAppBrowser,
              private navCtrl: NavController,
              wp: WpProvider,
              private spinnerDialog: SpinnerDialog,
              private linkService: PhcLinkServiceProvider,
              private analytics: AnalyticsProvider) {
    this.phcApp = wp.app;
  }

  activateItem(itemOrMenu: any){
    this.analytics.trackItem(itemOrMenu);
    if (itemOrMenu.type === 'menu') {
      this.navCtrl.push(SubmenuPage, { menu: itemOrMenu });
    } else if(itemOrMenu.type === 'item') {
      let link: PhcLink = itemOrMenu.link;
      this.linkService.activateLink(link, this.navCtrl);
    }
  }


  ngOnInit(){
    this.animateCycle = setInterval(() => {
      this.animating = sample(this.items);
      console.log(this.animating);
    }, 5000);
  }

  ngOnDestroy() {
    clearInterval(this.animateCycle);
  }

}



// WEBPACK FOOTER //
// ./src/components/phc-menu/phc-menu.ts